import { BetState, CashoutErrorCode, StakeState } from 'app/lib/staking/constants';

import dictionary from './MyStakes.dictionary.json';

export enum CheckboxName {
  stakeCashout,
  stakeCashoutIncrease,
  stakeCashoutDecrease,
}

export const CASHOUT_DEFAULT_ERROR_MESSAGES = {
  [CashoutErrorCode.AMOUNT_CHANGED]: dictionary.amountChanged,
  [CashoutErrorCode.BETTING_IS_CLOSED]: dictionary.bettingIsClosed,
  [CashoutErrorCode.CASH_OUT_IN_PROCESS]: dictionary.cashOutInProcess,
  [CashoutErrorCode.UNAUTHORIZED]: dictionary.unauthorized,
  [CashoutErrorCode.NOT_FOUND]: dictionary.notFound,
  [CashoutErrorCode.NOT_ACCEPTABLE]: dictionary.notAcceptable,
  [CashoutErrorCode.INTERNAL_SERVER_ERROR]: dictionary.internalServerError,
};

export const BET_STATE_DICTIONARY = {
  [BetState.ACTIVE]: dictionary.active,
  [BetState.WIN]: dictionary.win,
  [BetState.LOSE]: dictionary.lose,
  [BetState.RETURN]: dictionary.return,
  [BetState.CANCEL]: dictionary.cancel,
};

export const STAKE_STATE_DICTIONARY = {
  [StakeState.ACTIVE]: dictionary.active,
  [StakeState.WIN]: dictionary.win,
  [StakeState.LOSE]: dictionary.lose,
  [StakeState.RETURN]: dictionary.return,
  [StakeState.CANCEL]: dictionary.cancel,
  [StakeState.CASH_OUT]: dictionary.cashOut,
  [StakeState.PAID]: dictionary.paid,
  [StakeState.AWAITING]: dictionary.awaiting,
};

export enum EntriesStateType {
  ACTIVE = 'activeStakes',
  SIDEBAR = 'sidebarStakes',
  HISTORY = 'historyStakes',
}
